import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function SSOPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [validating, setValidating] = useState(true);

  useEffect(() => {
    const validateToken = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setError('No SSO token provided');
        setValidating(false);
        setTimeout(() => navigate('/login'), 3000);
        return;
      }

      try {
        const response = await axios.post(
          `${API_URL}/api/sso/validate`,
          { token },
          { withCredentials: true }
        );

        if (response.data.success) {
          // Success - redirect to dashboard
          navigate('/dashboard');
        } else {
          setError('SSO validation failed');
          setTimeout(() => navigate('/login'), 3000);
        }
      } catch (err) {
        const errorMessage = err.response?.data?.detail || err.message || 'SSO validation failed';
        setError(errorMessage);
        setValidating(false);
        setTimeout(() => navigate('/login'), 3000);
      }
    };

    validateToken();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F4F4F5] to-[#E4E4E7]">
      <div className="bg-white p-8 max-w-md w-full mx-4 border border-[#E4E4E7] shadow-sm">
        <div className="text-center">
          {validating && !error && (
            <>
              <div className="mb-4">
                <div className="inline-block w-12 h-12 border-4 border-[#0C9168] border-t-transparent rounded-full animate-spin"></div>
              </div>
              <h2 className="text-xl font-bold text-[#09090B] mb-2">
                Validating SSO Token...
              </h2>
              <p className="text-sm text-[#52525B]">
                Please wait while we verify your credentials from Pulse.
              </p>
            </>
          )}

          {error && (
            <>
              <div className="mb-4">
                <svg 
                  className="w-16 h-16 mx-auto text-[#DC2626]" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" 
                  />
                </svg>
              </div>
              <h2 className="text-xl font-bold text-[#09090B] mb-2">
                SSO Validation Failed
              </h2>
              <p className="text-sm text-[#DC2626] mb-4">
                {error}
              </p>
              <p className="text-xs text-[#52525B]">
                Redirecting to login page in 3 seconds...
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
